export default {
    name: 'zegna',
    appId: 'wxcc92c871c0188fe5',
    wechatId: '87',
    baseUrl: 'https://apistore.zegna.cn'
};
